import { useMemo } from "react";
import { useStyles } from "./RCAUploadZone.styles";
import { IRCAUploadZone, RCAUploadTypeEnum } from "./RCAUploadZoneInterfaces";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VideoFileOutlinedIcon from "@mui/icons-material/VideoFileOutlined";
import QueueOutlinedIcon from "@mui/icons-material/QueueOutlined";
import { useTranslation } from "react-i18next";

const uploadZoneHint = {
    [RCAUploadTypeEnum.DOCUMENT]: "(.pdf, .doc, .txt, .xls, .csv)",
    [RCAUploadTypeEnum.MEDIA]: "(.jpg, .png, .mov, .mp4)",
    [RCAUploadTypeEnum.ALL]: "(.pdf, .doc, .txt, .xls, .csv, .jpg, .png, .mov, .mp4)",
};

const RCAUploadZone = ({ uploadType }: IRCAUploadZone) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const uploadZoneIcon = useMemo(() => {
        return {
            [RCAUploadTypeEnum.DOCUMENT]: <DescriptionOutlinedIcon className={classes.icon} />,
            [RCAUploadTypeEnum.MEDIA]: <VideoFileOutlinedIcon className={classes.icon} />,
            [RCAUploadTypeEnum.ALL]: <QueueOutlinedIcon className={classes.icon} />,
        };
    }, [classes.icon]);

    return (
        <div className={classes.uploadZoneWrapper}>
            <div className={classes.mainLine}>
                {uploadZoneIcon[uploadType]} <span>{t("rca.upload_zone.title")}</span>
            </div>
            <div className={classes.hintLine}>{uploadZoneHint[uploadType]}</div>
        </div>
    );
};

export default RCAUploadZone;
